module.exports = __webpack_public_path__ + "img/c9d5ab50de604311b86788954d8cecbd.71254b69.png";